<template>
  <span>
    <span v-for="name in states" :key="name">
      <slot :name="name" />
    </span>
  </span>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { State } from 'xstate-v4'

@Component
class StateMatches extends Vue {
  @Prop({ required: true })
  state?: State<any, any>

  get states() {
    return this.state?.toStrings() || []
  }
}

export default toNative(StateMatches)
</script>
